import { render, staticRenderFns } from "./ReflectLMS.vue?vue&type=template&id=5c8d642f&scoped=true"
import script from "./ReflectLMS.vue?vue&type=script&lang=ts"
export * from "./ReflectLMS.vue?vue&type=script&lang=ts"
import style0 from "./ReflectLMS.vue?vue&type=style&index=0&id=5c8d642f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d642f",
  null
  
)

export default component.exports